var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component",class:[
    _vm.className,
    _vm.variantClassName,
    (_vm.variantClassName + "--" + _vm.size),
    (_vm.variantClassName + "--" + _vm.type)
  ],style:(_vm.styleObject),attrs:{"href":_vm.href,"disabled":_vm.disabledProperty,"data-test":_vm.className},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }